<template>
  <div class="bio-content">
    <div class="download flex ai-c">DOWNLOAD  PDF：<a @click="open('1')">CV</a> <div class="flex jc-c" style="width:8px">/</div> <a  @click="open('2')">简历</a></div>
    <div class="content" v-html="details"></div>
  </div>
</template>

<script>
import { resume } from '../../api'
export default {
  components:{},
  props:{},
  data(){
    return {
      details: ''
    }
  },
  watch:{},
  computed:{},
  methods:{
    resume() {
      resume({}).then(res=>{
        var dataArr = res.data.data.split('<p')
        var str = ''
        for (var i in dataArr) {
          if (i==0) {
            continue;
          }
          if (dataArr[i].indexOf('class="') == -1) {
            dataArr[i] = ` data-wow-duration="0.5s" data-wow-delay="${0.02*i}s" class="listWOW fadeInDown"` + dataArr[i]
          } else {
            dataArr[i] = dataArr[i].replace('class="', `data-wow-duration="0.5s" data-wow-delay="${0.02*i}s" class="listWOW fadeInDown `);
          }
          str += '<p' + dataArr[i]
        }
        
        this.details = str
        this.$nextTick(()=>{
            this.$wow('listWOW')
        })
      })
    },
    open(type){
      var siteInfo = JSON.parse(localStorage.getItem('siteInfo'))
      if (type==1) {
        window.open(siteInfo.en_resume)
      } else {
        window.open(siteInfo.zh_resume)
      }
    }
  },
  created(){
    this.resume()
  },
  mounted(){
    
  }
}
</script>
<style scoped>
.bio-content{
    padding-top:1.2rem;
}
.content{
  font-size: .2rem;
  font-weight: 400;
  color: #22B573;
  line-height: 1.1;
  margin-top: 1.15rem;
}
.content>>>*{
    font-size: .2rem !important;
    font-family: Arial;
    font-weight: 400;
    color: #22B573;
}
.download{
  font-size: 14px;
  font-family: KhmerSangamMN;
  /* font-weight: bold; */
  color: #22B573;
  /* margin-top: 100px; */
}
.download a{
  font-size: 14px;
  font-family: KhmerSangamMN;
  /* font-weight: bold; */
  color: #22B573;
  text-decoration:underline;
}
</style>
<style>
.wrapper{
  width: 100%!important;
  /* box-sizing: border-box; */
  /* width: 956px; */
}
</style>